import { render, staticRenderFns } from "./RawMatForm.vue?vue&type=template&id=3380a1c7&scoped=true&"
import script from "./RawMatForm.vue?vue&type=script&lang=js&"
export * from "./RawMatForm.vue?vue&type=script&lang=js&"
import style0 from "./RawMatForm.vue?vue&type=style&index=0&id=3380a1c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3380a1c7",
  null
  
)

export default component.exports